TasksOverview.$inject = ['$resource'];

export function TasksOverview($resource: angular.resource.IResourceService) {
  return $resource(
    '/api/task',
    {},
    {
      getAll: {
        method: 'GET',
        url: '/api/task/all',
        isArray: true,
        interceptor: {
          response(response) {
            return response.data;
          },
        },
      },
      getUsers: {
        method: 'GET',
        url: '/api/user/all',
        isArray: true,
        cache: true,
      },
    },
  );
}
